import ApplicationContext from "online-shopping-cargo-parent/dist/applicationContext";

export default class AdminPanelApplicationContext extends ApplicationContext {
  get mock() {
    return false;
  }

  get serviceUrl() {
    // REACT_APP_SERVICE_URL=http://bitcode-service:9091 yarn start
    return process.env.REACT_APP_SERVICE_URL;
  }
}
